import { render, staticRenderFns } from "./RegistroEstudiantes.vue?vue&type=template&id=0af9ea1a&"
import script from "./RegistroEstudiantes.vue?vue&type=script&lang=js&"
export * from "./RegistroEstudiantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports